import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { ErrorMessagesService } from './inputs/error-messages.service';
import {
  ResponsiveService,
  CustomToastersService,
  LayoutService,
  PrintPdfService,
  TokenStorageService,
  RedirectService,
  RouteHelperService,
  ScriptService,
  NotificationActionService,
  GraphService,
  AutoScrollOnDragService,
  ConnectionStateService,
  HideEditService,
  HandleImportService,
  TargetUrlService,
  ActiveDirectoryConfigService,
  EventsService,
  UploadFileService,
  DownloadFileService,
  PageStateService,
  TabSheetsService,
  UnsavedChangesProxyService,
  PowerDmsFilePickerService,
  AutoUpdateService,
  StartQuizService,
  MaintenanceModeService,
  TopNavBarService
} from './services';
import { AclListBuilderService } from './inputs/acl-selector/acl-list-builder.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { RatingClassPipe } from './pipes/rating-class.pipe';
import { AgencyDatePipe } from './pipes/agency-date.pipe';
import { RejectSummariesModalProxyService } from './modals/reject-summaries-modal/reject-summaries-modal-proxy.service';
import { APP_OWL_DATETIME_FORMAT } from '@app/shared/constants';
import { ByNamePipe } from './pipes/by-name.pipe';
import { FilterByPropPipe } from './pipes/filter-by-prop.pipe';
import { ByActivePipe } from './pipes/by-active.pipe';
import { ByRacePipe } from './pipes/by-race.pipe';
import { ByGenderPipe } from './pipes/by-sex.pipe';
import { BySelectedPipe } from './pipes/by-selected.pipe';
import { DragulaService } from 'ng2-dragula';
import { ArraySortByPropPipe } from './pipes/sort-by-prop.pipe';
import { ModalModule } from 'ngx-bootstrap/modal';
import { RejectPeSummariesModalProxyService } from 'src/app/shared/modals/reject-pe-summaries-modal/reject-pe-summaries-modal-proxy.service';
import { ChartDrawerFactory } from './content/chart/chart-drawer-factory';
import { TraineeToOtherRolesPipe } from './pipes/trainee-to-other-roles.pipe';
import { TrainerToOtherRolesPipe } from './pipes/trainer-to-other-roles.pipe';
import { GoalStatusPipe } from './utils/get-enum/get-goal-status';
import { HighFiveViewModalProxyService } from './modals/high-five-view-modal/high-five-view-modal-proxy.service';
import { ByFullNamePipe } from './pipes/by-full-name.pipe';
import { HistoryItemService } from './services/history-item.service';
import { OWL_DATE_TIME_FORMATS } from '@danielmoncada/angular-datetime-picker';
import { HighFiveDataService } from '@app/shared/services/high-five-data.service';
import { CallTypeMigrationService } from '@app/shared/services/call-type-migration.service';
import { StripHtmlPipe } from '@app/shared/pipes/strip-html.pipe';
import { FilterByPipe } from './pipes/filter-by.pipe';
import { ByPropPipe } from './pipes/by-prop.pipe';
import { FilterByPropsPipe } from './pipes/filter-by-item-props.pipe';
import { DescriptionModelService } from './services/description-model.service';

@NgModule({
  imports: [ModalModule],
  exports: [ModalModule]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: NgModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  public static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        ErrorMessagesService,
        ResponsiveService,
        AclListBuilderService,
        DatePipe,
        DecimalPipe,
        RatingClassPipe,
        AgencyDatePipe,
        RejectSummariesModalProxyService,
        CustomToastersService,
        { provide: OWL_DATE_TIME_FORMATS, useValue: APP_OWL_DATETIME_FORMAT },
        RedirectService,
        TokenStorageService,
        RouteHelperService,
        ScriptService,
        LayoutService,
        MaintenanceModeService,
        NotificationActionService,
        ByNamePipe,
        FilterByPropPipe,
        FilterByPropsPipe,
        ByRacePipe,
        ByGenderPipe,
        BySelectedPipe,
        GraphService,
        AutoScrollOnDragService,
        DragulaService,
        ArraySortByPropPipe,
        ConnectionStateService,
        HideEditService,
        HandleImportService,
        TargetUrlService,
        ActiveDirectoryConfigService,
        EventsService,
        UploadFileService,
        DownloadFileService,
        PageStateService,
        TabSheetsService,
        UnsavedChangesProxyService,
        RejectPeSummariesModalProxyService,
        ChartDrawerFactory,
        HighFiveViewModalProxyService,
        TraineeToOtherRolesPipe,
        TrainerToOtherRolesPipe,
        GoalStatusPipe,
        ByFullNamePipe,
        ByActivePipe,
        PrintPdfService,
        PowerDmsFilePickerService,
        AutoUpdateService,
        StartQuizService,
        HistoryItemService,
        HighFiveDataService,
        CallTypeMigrationService,
        StripHtmlPipe,
        FilterByPipe,
        ByPropPipe,
        TopNavBarService,
        DescriptionModelService
      ]
    };
  }
}

export function throwIfAlreadyLoaded(parentModule: any, moduleName: string): void {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
  }
}
